export const IMAGE_MAX_REFERENCE_COUNT = 3;
export const IMAGE_PROMPT_MAX_LENGTH = 2000;

export const IMAGE_SIZE_OPTIONS = [
  { value: '2048*2048', label: '2048×2048' },
  { value: '1664*928', label: '1664×928' },
  { value: '1472*1104', label: '1472×1104' },
  { value: '1328*1328', label: '1328×1328' },
  { value: '1104*1472', label: '1104×1472' },
  { value: '928*1664', label: '928×1664' },
  { value: '1024*1024', label: '1024×1024' },
];

export const IMAGE_COUNT_OPTIONS = [1, 2, 3, 4, 5, 6].map((count) => ({
  value: count,
  label: `${count} 张`,
}));

export const DEFAULT_IMAGE_PARAMS = {
  size: '2048*2048',
  count: 1,
  promptExtend: true,
};

export function normalizeImageParams(raw) {
  const source = raw && typeof raw === 'object' ? raw : {};
  const size = IMAGE_SIZE_OPTIONS.some((item) => item.value === source.size)
    ? source.size
    : DEFAULT_IMAGE_PARAMS.size;
  const countValue = Number(source.count ?? source.n);
  const count = IMAGE_COUNT_OPTIONS.some((item) => item.value === countValue)
    ? countValue
    : DEFAULT_IMAGE_PARAMS.count;
  return {
    size,
    count,
    promptExtend: source.promptExtend !== false,
  };
}

export function serializeImageParams(params) {
  const normalized = normalizeImageParams(params);
  return JSON.stringify({
    size: normalized.size,
    n: normalized.count,
    promptExtend: normalized.promptExtend,
  });
}

export function parseImageParamsJson(raw) {
  if (!raw) return { ...DEFAULT_IMAGE_PARAMS };
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return normalizeImageParams({
      size: parsed?.size,
      count: parsed?.n ?? parsed?.count,
      promptExtend: parsed?.promptExtend,
    });
  } catch {
    return { ...DEFAULT_IMAGE_PARAMS };
  }
}
